import React, { FunctionComponent } from 'react';
import {
  Box,
  VStack,
  HStack,
  StackDivider,
  Text,
  Link,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faNetworkWired,
  faGlobeAmericas,
} from '@fortawesome/pro-solid-svg-icons';

interface IProps {
  office: string;
  department: string;
}
const JobAsideMenu: FunctionComponent<IProps> = ({ office, department }) => (
  <VStack
    divider={<StackDivider borderColor="gray.200" />}
    mb="12"
    spacing="7"
    align="stretch"
  >
    <Link href="/jobs" color="black" textTransform="uppercase">
      <HStack mt="10">
        <Box mr="3">
          <FontAwesomeIcon icon={faArrowLeft} color="#6E7694" />
        </Box>
        <Text fontSize="md" fontWeight="medium">
          Roles at Hover
        </Text>
      </HStack>
    </Link>

    <HStack>
      <Box mr="3">
        <FontAwesomeIcon icon={faGlobeAmericas} />
      </Box>
      <Text fontSize="lg">{office}</Text>
    </HStack>

    <HStack>
      <Box mr="3">
        <FontAwesomeIcon icon={faNetworkWired} />
      </Box>
      <Text fontSize="lg">{department}</Text>
    </HStack>
  </VStack>
);

export default JobAsideMenu;
